import { defineComponent, reactive, watch } from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import { tran } from '@/utils/assist'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import { getMinMaxValue } from '../../topicCommonUtil'
import CommonTetxEdit from '@/components/CommonTetxEdit'

const UploadTopic = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    type: {
      //1:单选题  2:多选题
      type: Number,
      default: 1
    }
  },
  emits: ['completeEdit'],
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })

    watch(
      () => props.item,
      () => {
        state.editItem = _.cloneDeep(props.item)
      },
      {
        deep: true
      }
    )

    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const gcommonAnnexUploadAcitve = (file) => {
      let _type = file.type
      console.log(file, _type)
    }
    const handleRemove = (file, fileList) => {
      console.log(file, fileList)
    }
    const handleExceed = (files, fileList) => {
      // this.$message.warning(
      //   `当前限制选择 3 个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // )
    }
    const beforeRemove = (file) => {
      // return this.$confirm(`确定移除 ${file.name}？`)
    }
    return () => {
      return (
        <div style={{padding:'0px 24px'}}>
          <div class="topic-edit-content-item topic-edit-content-title">
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.attachmentName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <CommonTetxEdit
            needDynamicEvent
            initialData={state.editItem.topicSetting.topicRemark}
            placeholder={tran('survy.plcremark')}
            handleUpdate={(value) => {
              state.editItem.topicSetting.topicRemark = value
            }}
          />
          <div onClick={(e)=>e.preventDefault()}>
            <flycode-upload
              action=""
              multiple={true}
              show-file-list={true}
              list-type="text"
              file-list={[]}
              ref="gcommonAnnexUpload"
              readonly={false}
              activeList={['delete', 'preview', 'edit', 'download']}
              on-activefile={gcommonAnnexUploadAcitve}
              limit={0}
              class="survey_upload_topic"
            >
              <div class="upload_button">
                <el-button type="text">+ {tran('survy.clickUpload')}</el-button>
              </div>
              <div slot="tip" class="upload_tips">
                {tran('survy.uploadMaxSize')}
              </div>
            </flycode-upload>
          </div>
          {/* <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.attachmentEndword')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div> */}
          <Portal to="survey-option-settings">
            <OptionSettings
              type={19}// props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              maxAppendixNum={state.editItem.topicSetting.maxAppendixNum}
              onChangeMaxUploadSize={(value) => {
                state.editItem.topicSetting.maxAppendixNum = getMinMaxValue(
                  value,
                  9
                )//maxAppendixNum 后端新字段
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})

export default UploadTopic
